jQuery(document).ready(function($) {
    function handleQuote() {
        $('.quote').each(function(index, element) {
            const $quote = $(element);
            const $section = $quote.parents('.section');
            const height = $quote.outerHeight();
            $section.css('padding-bottom', height/2 + 'px');
            $section.css('margin-bottom', height/2 + 'px');
        });
    }
    handleQuote();
    $(window).on('resize', handleQuote);
});